var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4"},[_vm._v("\n    Coming Soon...\n")])}
var staticRenderFns = []

export { render, staticRenderFns }